(() => {
  angular
    .module('app')
    .controller('host.views.inpatientNprClaims', InpatientNprClaimsController);
      
  InpatientNprClaimsController.$inject = [
    '$state',
    '$stateParams',
    'abp.services.app.nprClaim',
    'Hms.Claims.ClaimType',
    'Hms.GuaranteeLetters.DeliveryType',
    'Hms.PaymentAccounts.PaymentAccount',
    'Abp.Configuration.Setting',
    'moment',
  ];

  function InpatientNprClaimsController(
    $state,
    $stateParams,
    nprClaimSvc,
    enumClaimType,
    enumDeliveryType,
    constsPaymentAccount,
    constsAbpConfig,
    moment) 
  {
    const vm = this;
    vm.constsPaymentAccount = constsPaymentAccount;
    vm.constsAbpConfig = constsAbpConfig;
    vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
    vm.loading = 0;
    vm.saving = 0;
    vm.claimTypeId = $stateParams.claimType;
    vm.employeeId = $stateParams.employeeId;
    vm.ticketNumber = $stateParams.ticketNumber;
    vm.updateBankingDetails = updateBankingDetails;
    vm.submitClaim = submitClaim;
    vm.ticket = [];
    vm.diagnosis = {
      selected: [],
      icd: []
    };
    vm.newAttachments = [];
    vm.hasInpatientClaimProcessingEnhancement = abp.setting.getBoolean('Hms.Feature.InpatientClaimProcessingEnhancement');
    vm.hasInsuranceEnhancementModule = abp.setting.getBoolean(
      'Hms.Feature.InsuranceEnhancementModule'
      );

    vm.enums = {};
    vm.enums.claimType = enumClaimType;
    vm.enums.deliveryType = enumDeliveryType;

    vm.issueMc = issueMc;
    vm.removeMc = removeMc;
    vm. setMcStartDate = setMcStartDate;
    vm.getMcDurationDescription = getMcDurationDescription;
    vm.getMcStartDateChoice = getMcStartDateChoice;

    init();

    function init() {
      vm.loading += 1;

      const input = $.extend({}, {
        claimType: vm.claimTypeId,
        employeeId: vm.employeeId,
        ticketNumber: vm.ticketNumber
      });

      nprClaimSvc.getNprClaimCreationDetails(input)
        .success((data) => {
          vm.claim = data;
          vm.patient = data.patient;
          vm.admissionRecord = data.admissionRecord;
          vm.bankingDetails = data.bankingDetails;
          vm.banks = data.banks || [];
          vm.claimTypes = data.claimTypes;
          vm.visitTypes = data.visitTypes;
          vm.diagnosis.icd = _.map(data.diseaseClassifications, (d) => ({
              id: d.id,
              code: d.code,
              description: `(${ d.code }) ${ d.description}`,
              parentDescription: `(${ d.parentCode }) ${ d.parentDescription}`
            }));

          vm.bankId = vm.bankingDetails && vm.bankingDetails.length > 0
            ? vm.bankingDetails[0].bankId
            : null;

          if (vm.bankId) {
            updateBankingDetails();
          }
        }).finally(() => {
          vm.loading -= 1;
        });
    }

    /* Medical Certificate Management */

    function issueMc() {
      const firstDate = moment(vm.receiptDate).startOf('day');
      vm.ticket.medicalCertificate = {
        startDate: firstDate,
        endDate: firstDate
      };
      vm.isMcStartDateAlsoCheckedInDate = 1;
    };

    function removeMc() {
      vm.ticket.medicalCertificate = null;
    };

    function setMcStartDate(offset) {
      const checkInDate = moment(vm.ticket.checkedInTime).startOf('day');
      vm.ticket.medicalCertificate.startDate = checkInDate.add(offset, 'days');

      const mcEndDate = vm.ticket.medicalCertificate.endDate.startOf('day');
      if (mcEndDate.diff(vm.ticket.medicalCertificate.startDate, 'days') < 0) {
        vm.ticket.medicalCertificate.endDate = moment(vm.ticket.medicalCertificate.startDate);
      }
      vm.isMcStartDateAlsoCheckedInDate = offset === 0;
    };

    function getMcDurationDescription() {
      if (vm.ticket.medicalCertificate) {
        const startDate = moment(vm.ticket.medicalCertificate.startDate);
        const endDate = moment(vm.ticket.medicalCertificate.endDate);
        const duration = endDate.diff(startDate, 'days') + 1;
        return App.localize('XDays', duration);
      }
      return '';
    };

    function getMcStartDateChoice(offset) {
      return moment(vm.ticket.checkedInTime).add(offset, 'days').startOf('day');
    };

    /* End of Medical Certificate Management */

    vm.uploadConfig = {
      objectType: 'ClaimAttachment'
    };

    function updateBankingDetails() {
      const bank = _.find(vm.bankingDetails, ['bankId', vm.bankId]);
      vm.paymentAccountId = bank ? bank.paymentAccountId : null;
      vm.accountNumber = bank ? bank.accountNumber : null;
      vm.recipientName = bank ? bank.recipientName : null;
      vm.emailAddress = bank ? bank.emailAddress : null;

      if (vm.emailAddress === null) {
        vm.emailAddress = vm.patient ? vm.patient.emailAddress : null;
      }
    }

    function submitClaim() {
      vm.loading += 1;

      vm.selectedDiagnosis = _.map(vm.diagnosis.selected, (d) => ({
          description: d.description,
          diagnosisDate: d.date
        }));

      const input = $.extend(vm.claim, {
        employeeId: vm.employeeId,
        paymentAccountId: vm.paymentAccountId,
        clinicName: vm.admissionRecord.panelName,
        clinicAddress: vm.admissionRecord.panelAddress,
        admissionDate: vm.admissionRecord.admissionDate,
        dischargeDate: vm.admissionRecord.dischargeDate,
        newAttachments: vm.newAttachments,
        medicalCertificate: vm.ticket.medicalCertificate,
        diagnoses: vm.selectedDiagnosis,
        bankingDetails: {
          bankId: vm.bankId,
          bankAccountNumber: vm.accountNumber,
          bankAccountName: vm.recipientName,
          paymentEmailAddresses: vm.emailAddress
        }
      });

      const isValidForm = App.isFormValid(vm.claimForm);
      if (!isValidForm) {
        vm.loading -= 1;
        return;
      }

      nprClaimSvc.submitClaim(input)
        .success(() => {
          abp.notify.info(App.localize("SuccessfullySaved"));
          $state.go('inpatientNpr');
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }
  }
})();
